import { useContext, useEffect } from "react";
import { UpdateContext } from "../context/UpdateContext";

export const useAppUpdate = () => {
  const { notifyUpdate } = useContext(UpdateContext);

  useEffect(() => {
    // Set the global callback so the service worker can trigger updates
    window.__setUpdateCallback = (registration) => {
      notifyUpdate(registration);
    };

    return () => {
      window.__setUpdateCallback = null;
    };
  }, [notifyUpdate]);
};
